import firebase from '../firebase'
import { GLP_LOGGED_COMPANY } from './types'

export const loggedInCompanyActions = companyID => {
  if (!companyID) return;
  
  firebase.database.ref(`companies/${companyID}`).on('value', function (data) {
    if (data.val()) {
      let company = data.val()
      localStorage.setItem(GLP_LOGGED_COMPANY, JSON.stringify(company))
    }
  })
}

export const fetchCompanyData = params => {
  return (dispatch, getState) => {
    // Skip if we don't have a company ID
    if (!params || !params.companyID) {
      return;
    }
    
    // Set loading state
    dispatch({ type: 'FETCHING_COMPANY_DATA' });
    
    // First get from localStorage to avoid flicker
    try {
      const cachedCompany = JSON.parse(localStorage.getItem(GLP_LOGGED_COMPANY));
      if (cachedCompany && cachedCompany.logo) {
        dispatch({ type: 'FETCHED_COMPANY_DATA', companydata: cachedCompany });
      }
    } catch(e) {
      
    }
    
    // Then fetch fresh data from Firebase
    firebase.database
      .ref(`companies/${params.companyID}`)
      .on('value', function (data) {
        if (data.val()) {
          let company = data.val()
          // Only update if we got valid data
          if (company) {
            localStorage.setItem(GLP_LOGGED_COMPANY, JSON.stringify(company));
            dispatch({ type: 'FETCHED_COMPANY_DATA', companydata: company });
          }
        } else {
          dispatch({ type: 'FETCHED_COMPANY_DATA', companydata: {} });
        }
      })
  }
}
